import React, { useState, useEffect } from 'react';
import { Typography, Paper, Chip, Button, Stack, Box, BottomNavigation, BottomNavigationAction, useMediaQuery, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ArrowBack, Directions, Share, ArrowForward } from '@mui/icons-material';
import { useTheme } from "@mui/material/styles";
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import Slider from "react-slick";
import { Helmet } from "react-helmet-async";
import SummaryComponent from './summaryComponent'
import FullscreenImageViewer from './fullScreenViewer';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "lite-youtube-embed";
import "lite-youtube-embed/src/lite-yt-embed.css";


const styles = {
  container: {
    width:{md:'50%', sm: '100%'},
    zIndex:5,
    display:'flex',
    flexDirection: 'column',
    position:'absolute',
    top:0,
    right:0,
    height:'100dvh',
    width:'100%',
    overflow:'hidden'
  },
  headerRow: {
    position:'relative',
    width:'95%',
    height: 56,
    pr: 2,
    pl:2,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    flexShrink: 0,
  },
  closeButton: {
    color:'#000000'
  },
  caraouselImg: {
    maxWidth: "100vw",
    maxHeight: "100%",
    objectFit: "contain",
    margin: "auto"
  },
  caraousel: {
    height:'55dvh',
  },
  caraouselContainer: {
    maxHeight: '55dvh',
      "& .slick-slider, & .slick-list, & .slick-track": {
            height: "100%",
            margin: "auto",
          },
  },
  summary: {
          flex: 1,
          overflowY: "auto",
          px: 2,
          py: 1,

        }
}
const gotoLoc = (latLong) =>{
    
    window.open(`https://www.google.com/maps/search/?api=1&query=${latLong.lat},${latLong.long}`);
}

const settings = {
  className: "",
  dots: true,
  slidesToShow: 1,
  slidesToScroll: 1,
};

const YoutubePreview = ({videoId}) => {
    if (videoId) {
        return (
            <lite-youtube
                key={videoId}
                videoid={videoId}
                style={{ width: "100%" }}
            />
        );
    }
    return null
}

const MyCarousel = ({photos=[], setFullscreenImage}) => {
      return (
        <Box sx={styles.caraouselContainer}>
          <Slider {...settings}>
              {photos.map(x=>(
              <Box sx={styles.caraousel} key={x.url}>
                <Box sx={{height: '90%', backgroundColor: "#000", position: 'relative', display: 'flex', flexDirection: 'column', alignItems:'center', justifyContent: 'center'}}>
                  {x.type === "image" && (<img  style={styles.caraouselImg} src={x.url} alt={x.alt || x.description} />)}
                  {x.type === "youtube" && (<YoutubePreview videoId={x.videoId}/>)}
                  {x.type === "image" &&  (<IconButton
                    onClick={() => setFullscreenImage(x.url)}
                    sx={{
                      position: "absolute",
                      bottom: 10,
                      right: 8,
                      bgcolor: "rgba(0,0,0,0.6)",
                      color: "white",
                      "&:hover": {
                        bgcolor: "rgba(0,0,0,0.8)",
                      },
                    }}
                  >
                  <OpenInFullIcon />
                  </IconButton>)}
                </Box>
                <p className='legend'>{x.description}</p>
              </Box>))}
          </Slider>
        </Box>
      );
  };
  
  const BottomBar = ({locationCords, title, prev, next}) => {    
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate();
    const [isShareSupported, setIsShareSupported] = useState(false);
    const params= useParams()
    const handleShare = async () => {
      if (navigator.share) {
        try {
            await navigator.share({
                title: title,
                url: window.location.href
            });
            console.log('Thanks for sharing!');
        } catch (error) {
            console.error('Error sharing:', error);
        }
      } 
    }

    useEffect(() => {
      // Check if the Web Share API is available
      if (navigator.share) {
        setIsShareSupported(true);
      }
    }, []);
    let prevPath;
    let nextPath;
    if (prev) {
        prevPath =  prev.slug ? `${prev.slug}_${prev._id}` : `${prev.title.toLowerCase().replaceAll(" ", "-")}_${prev._id}` 
    }
    if (next) {
        nextPath =  next.slug ? `${next.slug}_${next._id}` : `${next.title.toLowerCase().replaceAll(" ", "-")}_${next._id}` 
    }
    return (
      <BottomNavigation showLabels={!isMobile} style={{ width: '100%', flexShrink: 0, justifyContent: isMobile? 'space-between' : 'space-around' }}>
        <BottomNavigationAction 
          label="Previous" 
          icon={<ArrowBack sx={{color: !prev ? "text.disabled" : "inherit"}}/>}
          disabled={!prev}
          onClick={()=>{navigate(`/poi/${prevPath}`)}}  
        />
        <BottomNavigationAction 
          label="Directions" 
          icon={<Directions />}
          onClick={()=>{gotoLoc(locationCords)}}
        />
        {isShareSupported && (<BottomNavigationAction 
          label="Share" 
          icon={<Share />} 
          onClick={handleShare}
        />)}
        <BottomNavigationAction 
          label="Next" 
          icon={<ArrowForward sx={{color: !next ? "text.disabled" : "inherit"}}/>}
          disabled={!next}
          onClick={()=>{navigate(`/poi/${nextPath}`)}} 
        />
      </BottomNavigation>
    );
  };


const HelmetComponent = ({poiDetails}) => {
    if (poiDetails) {
        const url = poiDetails.slug ? `${poiDetails.slug}_${poiDetails._id}` : `${poiDetails.title.toLowerCase().replaceAll(" ", "-")}_${poiDetails._id}`
        return (
            <Helmet>
                <title>{poiDetails.title}</title>
                <meta property="og:type" content="article" />
                <meta property="og:title" content={poiDetails.title} />
                <meta property="og:description" content={poiDetails.title} />
                <meta property="og:url" content={`https://tripindex.in/poi/${url}`} />
                <meta property="og:image" content={`https://tripindex.in${poiDetails.media[0].url}`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={poiDetails.title} />
                <meta name="twitter:description" content={poiDetails.title} />
                <meta name="twitter:image" content={`https://tripindex.in${poiDetails.media[0].url}`} />
            </Helmet>
        )        
    }    
}

function Popup(props) {
  const { open, selectedLoc, selectedTrip, setOpen, tripFilter} = props;
  const navigate = useNavigate();
  const params= useParams()
  const [details, setDetails] = useState(undefined)
  const [fullscreenImage, setFullscreenImage] = useState(null);

    const getDetail = async(_id) => {
        if (_id) {
          //setOpen(true)
        try {
            const poiId = _id.split("_")[1] || _id
            const resp = await fetch(`/api/poi/${poiId}`);
            const _detail = await resp.json()

            setDetails(_detail)
        } catch (e) {
            console.log(e)
        }
        }
    }

    const handleDirectionClick  = () => {

    };

    const share = async () => {
        try {
            await navigator.share({
                title: 'Trip',
                text: props.name,
                url: `https://mapmafood.akbarali.co.in/restaurant/${selectedLoc}`,
            });
            console.log('Successfully shared');
        } catch (error) {
            console.error('Error sharing:', error);
        }
    };

    const theme = useTheme();

    useEffect(()=> {
        getDetail(selectedLoc)
    }, [selectedLoc])

    const {current:{media, id, title, type, locationCords, description, summary, slug}={}, prev, next }=details || {};
    const navUrl = (() => {
        if (tripFilter && tripFilter !== "all-trips") {
            if (tripFilter.slug) {
                return `/trip/${tripFilter.slug}_${tripFilter._id}`
            }
            return `/trip/${tripFilter._id}`
        }
        return "/"
    })()
    
  if(open) {
    return (
        <Paper sx={styles.container}>
            <HelmetComponent poiDetails={details?.current}/>
            <Box sx={styles.headerRow}>
                
                {title && (<Typography variant="h6" >{title}</Typography>)}
                <IconButton onClick={()=>{navigate(navUrl, { state: {loc:selectedLoc.split("_")[1], trip: params.loc_id}})}}>
                  <CloseIcon 
                      sx={styles.closeButton}
                  />
                </IconButton>
                
            </Box>
            <MyCarousel key={id} photos={media} setFullscreenImage={setFullscreenImage}/>

            <SummaryComponent><Typography align="justify" variant='body' dangerouslySetInnerHTML={{
            __html:summary}}></Typography></SummaryComponent>
            <BottomBar locationCords={locationCords} id={id} next={next} prev={prev} title={title || "My Trips"}/>
            <FullscreenImageViewer
              open={Boolean(fullscreenImage)}
              image={fullscreenImage}
              onClose={() => setFullscreenImage(null)}
            />
        </Paper>
    );
  }
  return null
}


export default Popup;
